import { colors, s16 } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const RadioFocusBox = styled.div`
  position: absolute;
  top: -1px;
  left: -1px;
  width: 26px;
  height: 26px;
  border: 2px solid ${colors.borderActionActive};
  border-radius: ${s16};
  pointer-events: none;
`;
